import { Filter, RotateCcw } from "lucide-react";
import { selectClass } from "../FormField";
import type { DashboardFilters, DashboardSummary } from "../../api/dashboardApi";

type Props = {
  filters: DashboardFilters;
  options: DashboardSummary["options"] | null;
  onChange: (filters: DashboardFilters) => void;
};

const FIELDS: Array<{ key: keyof DashboardFilters; option: keyof DashboardSummary["options"]; label: string; all: string }> = [
  { key: "insurer_id", option: "insurers", label: "Assureur", all: "Tous les assureurs" },
  { key: "hospital_id", option: "hospitals", label: "Prestataire", all: "Tous les prestataires" },
  { key: "company_id", option: "companies", label: "Entreprise", all: "Toutes les entreprises" },
  { key: "package_id", option: "packages", label: "Package", all: "Tous les packages" },
];

/** Filtres en haut du tableau de bord : changer d'assureur réinitialise prestataire, entreprise et package. */
export function DashboardFiltersBar({ filters, options, onChange }: Props) {
  const active = Object.values(filters).some(Boolean);

  const change = (key: keyof DashboardFilters, raw: string) => {
    const value = raw ? Number(raw) : null;
    onChange(key === "insurer_id" ? { insurer_id: value, hospital_id: null, company_id: null, package_id: null } : { ...filters, [key]: value });
  };

  return (
    <div className="theme-card flex flex-wrap items-end gap-3 p-4">
      <span className="flex items-center gap-2 self-center text-sm font-semibold text-foreground">
        <Filter size={16} className="text-primary" />
        Filtres
      </span>
      {FIELDS.map((field) => (
        <label key={field.key} className="flex min-w-[12rem] flex-1 flex-col gap-1 text-xs text-muted">
          {field.label}
          <select
            value={filters[field.key] ?? ""}
            onChange={(event) => change(field.key, event.target.value)}
            className={`${selectClass} h-9 text-sm`}
            aria-label={field.label}
          >
            <option value="">{field.all}</option>
            {(options?.[field.option] ?? []).map((option) => (
              <option key={option.id} value={option.id}>{option.name}</option>
            ))}
          </select>
        </label>
      ))}
      {active ? (
        <button
          type="button"
          onClick={() => onChange({ insurer_id: null, hospital_id: null, company_id: null, package_id: null })}
          className="inline-flex h-9 items-center gap-1 rounded-lg border border-border px-3 text-sm text-foreground hover:bg-card-muted"
        >
          <RotateCcw size={14} />
          Réinitialiser
        </button>
      ) : null}
    </div>
  );
}
